import * as React from 'react'
import { Box, Stack, styled, IconButton } from '@mui/material'
import { Typography as MIUTypography, Divider } from '@mui/material'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import FileOpenIcon from '@mui/icons-material/FileOpen'
import { ReactComponent as OrcidIcon } from '../../assets/icons/orcid.svg'
import { researchersNames, thesisStudents, contributors } from '../../utils'

const WIDTHMIN = 640
const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))
const Footer = ({ windowWidth }) => {
  const styleStackFooter = {
    direction: windowWidth < WIDTHMIN ? 'column' : 'row',
    alignItems: windowWidth < WIDTHMIN ? 'auto' : 'center',
    justifyContent: 'space-around',
    height: '100%',
    width: '100%',
    spacing: 1,
  }

  const IconSocial = ({ IconElement, hreff, name, ...rest }) => {
    return (
      <IconButton
        target="_blank"
        href={hreff}
        aria-label={name}
        size="small"
        sx={{ verticalAlign: 'baseline', p: '2px', ...rest }}>
        <IconElement fontSize="inherit" />
      </IconButton>
    )
  }

  const TextLabel = ({ name, orcid, linkedin, thesis }) => {
    return (
      <Typography sx={{ textAlign: 'center', fontSize: 15 }}>
        {name}
        {orcid && (
          <IconSocial IconElement={OrcidIcon} hreff={orcid} name="Orcid" ml={1} />
        )}
        {linkedin && (
          <IconSocial
            IconElement={LinkedInIcon}
            hreff={linkedin}
            name="LinkedIn"
            color="#0a66c2"
            fontSize={13}
            ml={orcid ? 0 : 1}
          />
        )}
        {thesis && (
          <IconSocial
            IconElement={FileOpenIcon}
            hreff={thesis}
            name="thesis"
            color="#25a52e"
            fontSize={13}
            ml={orcid || linkedin ? 0 : 1}
          />
        )}
      </Typography>
    )
  }

  return (
    <Box sx={{ width: '100%', pt: 6 }}>
      <Stack {...styleStackFooter}>
        <Box>
          <Typography istitle="true" sx={{ pt: 3, pb: 1, fontSize: 15 }}>
            INVESTIGADORES
          </Typography>
          {researchersNames.map(obj => (
            <TextLabel key={`researcher-${obj.name}`} name={obj.name} orcid={obj.orcid} />
          ))}
        </Box>
        <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
          <Typography istitle="true" sx={{ pt: 3, pb: 1, fontSize: 15 }}>
            ASESORES
          </Typography>
          <TextLabel
            name="Ing. Tatiana Ojeda, Mg. Sc."
            orcid="https://orcid.org/0000-0002-9211-5344"
          />
          <TextLabel
            name="Ing. Paul Eguiguren, Mg. Sc."
            orcid="https://orcid.org/0000-0001-8973-0664"
          />
          <TextLabel name="Ing. Santiago Silva, Mg. Sc." />
          <Typography istitle="true" sx={{ pt: 4, pb: 1, fontSize: 15 }}>
            DESARROLLADOR WEB
          </Typography>
          <TextLabel
            name="Ing. Johnny González"
            linkedin="https://www.linkedin.com/in/johgg10"
            orcid="https://orcid.org/0000-0002-4844-6453"
            thesis="https://dspace.unl.edu.ec/jspui/handle/123456789/26629"
          />
        </Box>
      </Stack>
      <Divider sx={{ py: 2 }}>
        <Typography istitle="true" sx={{ pt: 1.3, pb: 1, fontSize: 15 }}>
          TESISTAS
        </Typography>
      </Divider>
      <Box>
        <Stack {...styleStackFooter} sx={{ pb: 2 }}>
          <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
            {thesisStudents.map((obj, i) =>
              i <= 7 ? (
                <TextLabel
                  key={`researcher-${obj.name}`}
                  name={obj.name}
                  thesis={obj.thesis}
                />
              ) : null
            )}
          </Box>
          <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
            {thesisStudents.map((obj, i) =>
              i > 7 && i <= 15 ? (
                <TextLabel
                  key={`researcher-${obj.name}`}
                  name={obj.name}
                  thesis={obj.thesis}
                />
              ) : null
            )}
          </Box>
          <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
            {thesisStudents.map((obj, i) =>
              i > 15 ? (
                <TextLabel
                  key={`researcher-${obj.name}`}
                  name={obj.name}
                  thesis={obj.thesis}
                />
              ) : null
            )}
          </Box>
        </Stack>
      </Box>

      <Divider sx={{ py: 2 }}>
        <Typography istitle="true" sx={{ pt: 1.3, pb: 1, fontSize: 15 }}>
          COLABORADORES
        </Typography>
      </Divider>
      <Box
        sx={{
          background: `linear-gradient(rgb(255 255 255 / 0%) 70%, rgb(42 165 46 / 8%) 100%)`,
        }}>
        <Stack {...styleStackFooter} sx={{ pb: 7 }}>
          <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
            {contributors.map((obj, i) =>
              i <= 9 ? <TextLabel key={`researcher-${obj.name}`} name={obj.name} /> : null
            )}
          </Box>
          <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
            {contributors.map((obj, i) =>
              i > 9 && i <= 20 ? (
                <TextLabel key={`researcher-${obj.name}`} name={obj.name} />
              ) : null
            )}
          </Box>
          <Box sx={{ alignSelf: windowWidth < WIDTHMIN ? 'auto' : 'start' }}>
            {contributors.map((obj, i) =>
              i > 20 ? <TextLabel key={`researcher-${obj.name}`} name={obj.name} /> : null
            )}
          </Box>
        </Stack>
      </Box>
    </Box>
  )
}

export default Footer
